import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Certificates } from 'server/shared/collections/certificates';
import { Customers } from 'server/shared/collections/customers';
import { Organisations } from 'server/shared/collections/organisations';
import { Users } from 'server/shared/collections/users';
import { Certificate } from 'server/shared/models/certificate';
import { Customer } from 'server/shared/models/customer';
import { Department } from 'server/shared/models/department';
import { Organisation } from 'server/shared/models/organisation';
import { RoleEnum } from 'server/shared/models/role.enum';
import { ShiftEnum } from 'server/shared/models/shift.enum';
import { DispoUser } from 'server/shared/models/user';
export type CreateEmploymentData = {
  departmentId?: string;
  startDate?: string;
  endDate?: string;
  certificates?: string;
};

@Component({
  selector: 'temp-work-selected-availability-dialog',
  styleUrls: ['employment-selected-availability-dialog.scss'],
  templateUrl: 'employment-selected-availability-dialog.html',
})
export class EmploymentSelectedAvailabilityDialogComponent
  implements OnInit, OnDestroy
{
  loggedInUser?: DispoUser;
  customer?: Customer;

  certificates: Certificate[] = [];
  organisation?: Organisation;
  department?: Department;

  private userTracker?: Tracker.Computation;

  constructor(
    public dialogRef: MatDialogRef<EmploymentSelectedAvailabilityDialogComponent>,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA)
    public data: CreateEmploymentData,
  ) {
    this.organisation = Organisations.findOne({
      'departments.id': this.data.departmentId,
    });
    this.department = this.organisation?.departments.find(
      (department) => department.id === this.data.departmentId,
    );
    const certificates = this.data.certificates?.split(',') || [];
    this.certificates = Certificates.find({
      _id: { $in: certificates },
    }).fetch();
  }

  ngOnInit() {
    this.userTracker = Tracker.autorun(async () => {
      this.loggedInUser = Users.findOne({
        _id: Meteor.userId(),
        role: RoleEnum.DISPO,
      }) as DispoUser;
      this.customer = Customers.findOne({ _id: this.loggedInUser?.customerId });
    });
  }

  ngOnDestroy() {
    if (this.userTracker) {
      this.userTracker.stop();
    }
  }

  continue(): void {
    this.dialogRef.close({
      departmentId: this.data.departmentId,
      startDate: this.data.startDate,
      endDate: this.data.endDate,
      certificates: this.data.certificates,
    });
  }
  close(): void {
    this.dialogRef.close(false);
  }

  protected readonly ShiftEnum = ShiftEnum;
}
